import { RCAlertBox, buttonClassName } from '@reverbdotcom/cadence/components';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import React from 'react';
import I18n from 'i18n-js';
import DocumentBrandIcon from '@reverbdotcom/cadence/icons/brand/document-orange.svg';

interface Props {
  message: string;
  headline: string;
  buttonText: string;
}

function TaxInformationBanner({ message, headline, buttonText }: Props) {
  return (
    <RCAlertBox
      type="info"
    >
      <div className="g-container g-container--cycle d-flex mobile-d-block fx-align-center fx-justify-between">
        <div className="d-flex fx-align-center fx-grow g-col-mobile-12">
          <img
            style={{ width: '5rem' }}
            className='mr-2'
            src={DocumentBrandIcon}
            alt={I18n.t('discovery.taxProfile.banner.documentAlt')}
          />
          <div>
            <h2 className='weight-bold'>
              {headline}
            </h2>
            <span>
              {message}
            </span>
          </div>
        </div>
        <div className='mr-2 g-col-mobile-12'>
          <CoreLink
            className={buttonClassName({ variant: 'primary' })}
            to="/my/selling/tax_id"
          >
            {buttonText}
          </CoreLink>
        </div>
      </div>
    </RCAlertBox>
  );
}

export default TaxInformationBanner;
